import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @file Upload.ts
 * @author markJia(markjia@tencent.com)
 */
import { Emitter } from '@tencent/glue-util-emitter';
import { FileItem, UploadStatus } from './FileItem';
export var Upload = /*#__PURE__*/function (_Emitter) {
  _inherits(Upload, _Emitter);

  var _super = _createSuper(Upload);

  function Upload() {
    var _this;

    _classCallCheck(this, Upload);

    _this = _super.apply(this, arguments);
    _this.accept = '*/*';
    _this.isMultiple = false; // {[guid]: FileItem}[]; 主要用来cancel的，先不实现

    _this.fileItemMap = {}; // 用于渲染

    _this.fileItems = [];

    _this.addFiles = function (files) {
      files.forEach(function (file) {
        var fileItem = new FileItem({
          file: file
        });
        _this.fileItemMap[fileItem.id] = fileItem;

        _this.fileItems.push(fileItem);

        _this.request(fileItem);
      });
    };

    _this.replaceById = function () {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (!_this.fileItemMap[id]) {
        console.error("card id: ".concat(id, "\u4E0D\u5B58\u5728\uFF0C\u65E0\u6CD5\u627E\u5230\u66FF\u6362item"));
        return;
      }

      var input = document.createElement('input');
      input.type = 'file';
      input.accept = _this.accept;

      input.onchange = function (e) {
        var _a, _b;

        var file = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0];

        if (!file) {
          // TODO: 什么情况下为空呢？
          console.error('error: file 为空，请检查');
          return;
        }

        var fileItem = new FileItem({
          file: file
        });
        _this.fileItemMap[fileItem.id] = fileItem;

        var index = _this.getIndexById(id);

        _this.fileItems.splice(index, 1, fileItem);

        _this.emit('file-items-change');

        _this.request(fileItem);
      };

      input.click();
    };

    _this.removeById = function () {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (!_this.fileItemMap[id]) {
        console.error("card id: ".concat(id, "\u4E0D\u5B58\u5728\uFF0C\u65E0\u6CD5\u5220\u9664item"));
        return;
      }

      var index = _this.getIndexById(id);

      var fileItem = _this.fileItems.splice(index, 1)[0];

      fileItem.updateFileItem({
        status: UploadStatus.REMOVED,
        percent: 0
      });

      _this.emit('upload-change', _objectSpread(_objectSpread({}, fileItem.getInfo()), {}, {
        response: null,
        index: index
      }));
    };

    _this.shouldUpload = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
        var _a, result;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (_a = _this.beforeUpload) === null || _a === void 0 ? void 0 : _a.call(_assertThisInitialized(_this), file);

              case 2:
                result = _context.sent;

                if (!(result == null || result === true)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", true);

              case 5:
                if (!(result === false)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", false);

              case 7:
                if (!(result instanceof File)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", result);

              case 9:
                return _context.abrupt("return", true);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    return _this;
  }

  _createClass(Upload, [{
    key: "updateOptions",
    value: function updateOptions(ops) {
      var _ops$accept = ops.accept,
          accept = _ops$accept === void 0 ? '*/*' : _ops$accept,
          requestConfig = ops.requestConfig,
          _ops$value = ops.value,
          value = _ops$value === void 0 ? [] : _ops$value,
          _ops$isMultiple = ops.isMultiple,
          isMultiple = _ops$isMultiple === void 0 ? false : _ops$isMultiple,
          beforeUpload = ops.beforeUpload;
      this.accept = accept;
      this.isMultiple = isMultiple;
      this.requestConfig = requestConfig;
      this.updateValue(value);
      this.beforeUpload = beforeUpload;
    }
    /**
    *
    * @param value 包括两种类型: url、File、uploadFile
    */

  }, {
    key: "updateValue",
    value: function updateValue(value) {
      // fileItems有上传状态，用于渲染
      var isNeedUpdate = false;
      var nextFileItems = [];

      if (value.length !== this.fileItems.length) {
        isNeedUpdate = true;
      }

      var _iterator = _createForOfIteratorHelper(value),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var fileItem = void 0;
          var _item$id = item.id,
              id = _item$id === void 0 ? '' : _item$id,
              url = item.url;
          fileItem = this.fileItemMap[id]; // 直接回填url

          if (!fileItem) {
            isNeedUpdate = true;
            fileItem = new FileItem({
              id: id,
              url: url
            });
            this.fileItemMap[fileItem.id] = fileItem;
            nextFileItems.push(fileItem);
            continue;
          } // 去除 response，index 和 fileItemInfo 一致
          // bugfix: 只判断status是否一致就行了


          if (item.status !== fileItem.status) {
            fileItem.updateFileItem(item);
            isNeedUpdate = true;
          }

          nextFileItems.push(fileItem);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.fileItems = nextFileItems;

      if (isNeedUpdate) {
        this.emit('file-items-change');
      }
    }
  }, {
    key: "getIndexById",
    value: function getIndexById(id) {
      var _iterator2 = _createForOfIteratorHelper(this.fileItems.entries()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              idx = _step2$value[0],
              item = _step2$value[1];

          if (item.id === id) {
            return idx;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return -1;
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fileItem) {
        var _this2 = this;

        var _a, res, _this$requestConfig, uploadUrl, name, data, headers, formData, uploadData, uploadHeaders, onUploadProgress, index, xhr, _this$requestConfig2, CancelToken, request, isCancel, cancelToken, resp;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.requestConfig) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (fileItem.file) {
                  _context2.next = 4;
                  break;
                }

                throw new Error('request只用于上传file类型的fileItem');

              case 4:
                _context2.next = 6;
                return this.shouldUpload(fileItem.file);

              case 6:
                res = _context2.sent;

                if (!(res === false)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return");

              case 9:
                if (res instanceof File) {
                  fileItem.file = res;
                }

                _this$requestConfig = this.requestConfig, uploadUrl = _this$requestConfig.uploadUrl, name = _this$requestConfig.name, data = _this$requestConfig.data, headers = _this$requestConfig.headers;
                formData = new FormData();
                formData.append(name, fileItem.file);
                uploadData = data;

                if (!(typeof data === 'function')) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 17;
                return data();

              case 17:
                uploadData = _context2.sent;

              case 18:
                uploadData && Object.entries(uploadData).forEach(function (_ref2) {
                  var _ref3 = _slicedToArray(_ref2, 2),
                      k = _ref3[0],
                      v = _ref3[1];

                  return formData.append(k, v);
                });
                uploadHeaders = headers;

                if (!(typeof headers === 'function')) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 23;
                return headers();

              case 23:
                uploadHeaders = _context2.sent;

              case 24:
                onUploadProgress = function onUploadProgress(e) {
                  fileItem.file && _this2.emit('progress-change', e, fileItem.file);
                };

                index = this.getIndexById(fileItem.id);
                xhr = {};
                fileItem.updateFileItem({
                  status: UploadStatus.UPLOADING,
                  percent: 0,
                  xhr: xhr
                });
                this.emit('upload-change', _objectSpread(_objectSpread({}, fileItem.getInfo()), {}, {
                  response: null,
                  index: index
                }));
                _this$requestConfig2 = this.requestConfig, CancelToken = _this$requestConfig2.CancelToken, request = _this$requestConfig2.request, isCancel = _this$requestConfig2.isCancel;
                _context2.prev = 30;
                cancelToken = CancelToken && new CancelToken(function (r) {
                  return xhr.cancel = r;
                });
                _context2.next = 34;
                return request.post(uploadUrl, formData, {
                  headers: uploadHeaders,
                  onUploadProgress: onUploadProgress,
                  cancelToken: cancelToken
                });

              case 34:
                resp = _context2.sent;
                fileItem.updateFileItem({
                  status: UploadStatus.SUCCESS,
                  percent: 100
                });
                this.emit('upload-change', _objectSpread(_objectSpread({}, fileItem.getInfo()), {}, {
                  response: resp.data,
                  index: index
                }));
                _context2.next = 46;
                break;

              case 39:
                _context2.prev = 39;
                _context2.t0 = _context2["catch"](30);

                if (!(isCancel === null || isCancel === void 0 ? void 0 : isCancel(_context2.t0))) {
                  _context2.next = 43;
                  break;
                }

                return _context2.abrupt("return");

              case 43:
                console.log('error: ', _context2.t0);
                fileItem.updateFileItem({
                  status: UploadStatus.ERROR,
                  errMsg: (_a = _context2.t0.message) !== null && _a !== void 0 ? _a : _context2.t0,
                  percent: 0
                });
                this.emit('upload-change', _objectSpread(_objectSpread({}, fileItem.getInfo()), {}, {
                  response: null,
                  index: index
                }));

              case 46:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[30, 39]]);
      }));

      function request(_x2) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }]);

  return Upload;
}(Emitter);